import { useHasMounted } from "../hooks/useHasMounted";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { WireWorldCanvas } from "./WireWorldWallpaper/Canvas";

type CommonPageProps = {
  children?: React.ReactNode;
};

export const CommonPage: React.FC<CommonPageProps> = (props) => {
  const hasMounted = useHasMounted();

  return (
    <>
      <div className="flex min-h-screen w-full flex-col font-sans text-slate-900 dark:text-slate-100">
        {hasMounted && <WireWorldCanvas />}
        <Header />
        <main className="m-4 grow lg:ps-[calc(100vw-100%)]">
          <div className="mx-auto w-full max-w-(--breakpoint-lg)">
            {props.children}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};
